import React from "react";
import { useSelector } from "react-redux";
import SendingFailed from "./SendingFailed.js";
import { FileLoaderCircleHoc, Upload3Hoc } from "../../../../../src/assets/images";
import { getActiveConversationChatId } from "../../../../Helpers/Chat/ChatHelper";
import { store } from "../../../../Redux/store.js";
import { CancelMediaUpload, RetryMediaUpload } from "../../../../Redux/feature/chatConversationHistorySlice.js";
import { blockOfflineMsgAction } from "../../../../Helpers/Utility.js";

function ProgressLoader(props = {}) {
  const {
    msgId = "",
    file_url = "",
    isSender = true,
    uploadStatus = 0,
    imgFileDownloadOnclick,//click
  } = props;

  const globalStore = useSelector((state) => state);
  const {
    appOnlineStatus: { isAppOnline } = {},
    mediaUploadData: { data = {} } = {}
  } = globalStore || {};

  const getAnimateClass = () => ((data[msgId]?.progress === 100 || uploadStatus === 0 )? "progress-animate" : "");

  const getActiveProgressClass = () => (uploadStatus === 1 && data[msgId]?.progress < 100 ? "active-progress" : "");

  const cancelMediaUpload = () => {
    if (uploadStatus === 8) return true;

    if (data[msgId]) {
      data[msgId].source.cancel("User Cancelled!");
    }

      if (uploadStatus === 0 || uploadStatus === 1) {
      const cancelObj = {
        msgId,
        fromUserId: getActiveConversationChatId(),
        uploadStatus: 7
      };
      store.dispatch(CancelMediaUpload(cancelObj));
    }
    return false;
  };

  const retryMediaUpload = () => {
    if(blockOfflineMsgAction()) return false;
    const retryObj =  {
      msgId,
      fromUserId: getActiveConversationChatId(),
      uploadStatus: 1
    };
    store.dispatch(RetryMediaUpload(retryObj));
  };

  const handleMediaClick = (e) => {
    if (isSender) {
      imgFileDownloadOnclick(e);
    } else {
      retryMediaUpload();
    }
  };

  const commonRetryAction = () => {
    return (
      <div
        id={file_url}
        className="reLoadFile"
        onClick={handleMediaClick}
        data-jest-id={"jesthandleMediaClick"}
      >
        <Upload3Hoc viewBox="0 0 14.56 14.56" id={file_url} onClick={handleMediaClick} />
        <span id={file_url} className="Retry">Retry</span>
      </div>
    );
  };

  const getSyncClass = () => (isSender ? "sync left" : "sync right");
  const progressView = () => {
    return (
  <div className={`loadingProgress ${getSyncClass()}`}>
  <Upload3Hoc viewBox="0 0 14.56 14.56"/>
  <span className="progressBar progress-animate" style={{ width: "50%" }}></span>
</div>
    );
  };
  const progressViewdiffer=()=> setTimeout(() => {
    progressView();
  }, 200);
  return (
    <React.Fragment>
      <div className="progressOverlay">
        {isAppOnline && (uploadStatus === 1 || uploadStatus === 0 || uploadStatus === 8) ? (
          <>
            <div
              data-jest-id={"jestcancelMediaUpload"}
              className="fileInprogess" onClick={cancelMediaUpload}>
              <FileLoaderCircleHoc viewBox="0 0 14 14" />
            </div>
            <div className="loadingProgress" onClick={cancelMediaUpload}>
              <span
                className={`progressBar ${getAnimateClass()} ${getActiveProgressClass()}`}
                style={{ width: `${data[msgId]?.progress}%` }}
              ></span>
            </div>
          </>
        ) : null}
        {uploadStatus === 3 && commonRetryAction()}
        {uploadStatus === 4 && isAppOnline ? progressViewdiffer()
         : null}

        {uploadStatus === 5 && (
          <div className="reLoadFile failed">
            <span className="failed-text">File doesn't exists</span>
          </div>
        )}

        {(uploadStatus === 6 || ((uploadStatus === 4 || uploadStatus === 1 || uploadStatus === 0) && !isAppOnline)) &&
          commonRetryAction()}
      </div>

      {(uploadStatus === 3 || ((uploadStatus === 1 || uploadStatus === 0) && !isAppOnline)) && <SendingFailed />}
    </React.Fragment>
  );
}

export default ProgressLoader;
